import React__default, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { getLabelValue } from '../i18n/utils.js';
import LandingPageLayout from '../LandingPage/index.js';
import KKeycloakAutomaticAuth from '../LandingPage/KKeycloakAutomaticAuth/index.js';
import KKeycloakCredentialAuthButton from '../LandingPage/KKeycloakCredentialAuthButton/index.js';
import KLandingHeader from '../LandingPage/KLandingHeader/index.js';
import { DisplayMode } from '../LandingPage/types.js';
import { addAuthButtonComponents } from './utils.js';

var KFLandingPageErrors;
(function (KFLandingPageErrors) {
    KFLandingPageErrors["LOGIN_ERROR_NO_ACCESS"] = "login.error.no_access";
    KFLandingPageErrors["COOPTATION_TOKEN_INVALID"] = "cooptation.token.invalid";
})(KFLandingPageErrors || (KFLandingPageErrors = {}));
var KFLandingPage = function (_a) {
    var _b;
    var loginUrl = _a.loginUrl, guestLoginUrl = _a.guestLoginUrl, requestAccountUrl = _a.requestAccountUrl, backgroundSrc = _a.backgroundSrc, logoLoginSrc = _a.logoLoginSrc, helpLinkHref = _a.helpLinkHref, idps = _a.idps, labels = _a.labels, errorCode = _a.errorCode, locales = _a.locales, onChangeLocaleFallBack = _a.onChangeLocaleFallBack, _c = _a.testId, testId = _c === void 0 ? "KFLandingPage" : _c;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var _d = useTranslation("refront-components"), t = _d.t, i18n = _d.i18n;
    var _e = useState(i18n.language), selectedLocale = _e[0], setSelectedLocale = _e[1];
    var onLocaleChange = function (locale) {
        if (locale) {
            i18n.changeLanguage(locale);
            setSelectedLocale(locale);
            if (onChangeLocaleFallBack) {
                onChangeLocaleFallBack(locale);
            }
        }
    };
    useEffect(function () {
        if (errorCode) {
            var messageKey = "components.kf-landing-page.login.error.generic";
            var customMessageKey = "login.error.generic";
            if (Object.values(KFLandingPageErrors).includes(errorCode)) {
                messageKey = "components.kf-landing-page.".concat(errorCode);
                customMessageKey = errorCode;
            }
            enqueueSnackbar(getLabelValue(customMessageKey, selectedLocale, t(messageKey), labels), {
                variant: "error"
            });
        }
    }, [enqueueSnackbar, errorCode, labels, selectedLocale, t]);
    var bottomComponents = [];
    var idpConfigured = (_b = (idps && idps.length > 0)) !== null && _b !== void 0 ? _b : false;
    addAuthButtonComponents(idpConfigured, loginUrl, bottomComponents, guestLoginUrl, requestAccountUrl, labels);
    return (React__default.createElement(LandingPageLayout, { backgroundSrc: backgroundSrc || "", logoLoginSrc: logoLoginSrc || "", className: "LandingPage", testId: testId, header: React__default.createElement(KLandingHeader, { displayAppTitle: false, logoCentered: false, logoMaxHeight: 50, logoLoginSrc: logoLoginSrc, locales: locales === null || locales === void 0 ? void 0 : locales.map(function (l) { return l.toLowerCase(); }), onLocaleChange: onLocaleChange }), mainAuthMethod: idpConfigured ? (React__default.createElement(KKeycloakAutomaticAuth, { idps: idps, helpLinkHref: helpLinkHref, labels: labels, locale: selectedLocale })) : (loginUrl && (React__default.createElement(KKeycloakCredentialAuthButton, { loginUrl: loginUrl, labels: labels, defaultDisplayMode: DisplayMode.Button }))), bottomComponents: bottomComponents, subtitle: getLabelValue("welcome_message", selectedLocale, t("components.landing.page.subtitle"), labels) }));
};

export { KFLandingPageErrors, KFLandingPage as default };
//# sourceMappingURL=index.js.map
